import {clone_form_group} from '../form_group_cloner.js'

$(document).ready ->
  if $('body').is('body.admin_organization_merger')
    $('a#add_source_field').click ->
      form_group = $('input#source_ues_ids_').last().closest('.form-group')
      clone_form_group(form_group, {input: ''})
